.spacer {
    display: block;
}

.match {
    composes: spacer;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: spacer;
    composes: contrast from "../../styles/theming.module.css";
}

.nano {
    height: var(--spacer-block-nano);
}

.micro {
    height: var(--spacer-block-micro);
}

.xxxlarge {
    height: var(--spacer-block-xxxlarge);
}
